// extracted by mini-css-extract-plugin
export default {"page":"fKq3QlhqXcHFSGmBvDXq__page___","container":"CCc9WOaLYfecojPacLoc__container___","pageWrapper":"BXD1q8XIrUK2fNZ3kIE___pageWrapper___"};